<template>
  <div>
    <div class="service-requests px-3" v-if="serviceRequests(value) && serviceRequests(value).length > 0">
      <div class="row no-gutters" v-if="serviceRequestsFulfil(value).length > 0">
        <div class="col">
          <a class="py-2">
            <h4 class="mr-2 bigger svg">
              <span class="text-success">
                <YesIcon></YesIcon>
              </span>
              {{ $t("fulfiledServicesRequests") }}
            </h4>
          </a>
        </div>
      </div>
      <div class="mb-3 mx-2">
        <div
          v-for="serviceRequest in serviceRequestsFulfil(value)"
          :key="`service-request-fulfil-${serviceRequest.id}`"
        >
          <strong class="py-2 d-block border-bottom" v-if="serviceById(serviceRequest.service_id)">
            {{ serviceById(serviceRequest.service_id).name[authLocale] }}
          </strong>
        </div>
      </div>
      <div class="row no-gutters" v-if="serviceRequestsFail(value).length > 0">
        <div class="col">
          <a class="py-2">
            <h4 class="mr-2 bigger svg">
              <span class="text-danger">
                <NoIcon></NoIcon>
              </span>
              {{ $t("failedServicesRequests") }}
            </h4>
          </a>
        </div>
      </div>
      <div class="mb-3 mx-2">
        <div
          v-for="serviceRequest in serviceRequestsFail(value)"
          :key="`service-request-fail-${serviceRequest.id}`"
        >
          <strong class="py-2 d-block border-bottom" v-if="serviceById(serviceRequest.service_id)">
            {{ serviceById(serviceRequest.service_id).name[authLocale] }}
          </strong>
        </div>
      </div>
      <div class="row no-gutters" v-if="serviceRequestsCancel(value).length > 0">
        <div class="col">
          <a class="py-2">
            <h4 class="mr-2 bigger svg">
              <span class="text-primary">
                <RemoveIcon></RemoveIcon>
              </span>
              {{ $t("canceledServicesRequests") }}
            </h4>
          </a>
        </div>
      </div>
      <div class="mx-2">
        <div
          v-for="serviceRequest in serviceRequestsCancel(value)"
          :key="`service-request-cancel-${serviceRequest.id}`"
        >
          <strong class="py-2 d-block border-bottom">
            {{ serviceById(serviceRequest.service_id).name[authLocale] }}
          </strong>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-secondary mt-3">
      {{ $t('noservicerequests') }}
    </div>
  </div>
</template>
<script>
import YesIcon from "@/components/Icons/Yes";
import NoIcon from "@/components/Icons/No";
import RemoveIcon from "@/components/Icons/Remove";
import { mapGetters } from "vuex";
export default {
  components: {
    YesIcon,
    NoIcon,
    RemoveIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      keyword: null,
      show: false,
      searching: false
    };
  },
  computed: {
    ...mapGetters({
      authLocale: "auth/locale",
      services: "staticservice/services",
      serviceById: "staticservice/byId",
      serviceRequests: "pcase/serviceRequests",
      serviceRequestsIds: "pcase/serviceRequestsIds",
      serviceRequestsActive: "pcase/serviceRequestsActive",
      serviceRequestsFulfil: "pcase/serviceRequestsFulfil",
      serviceRequestsFail: "pcase/serviceRequestsFail",
      serviceRequestsCancel: "pcase/serviceRequestsCancel"
    }),
    filteredServices() {
      const ret = [];
      for (const s of this.services) {
        if (this.serviceRequestsIds(this.value).includes(s.id)) {
          continue;
        }
        if (!this.keyword) {
          ret.push(s);
        } else if (s.name[this.authLocale].indexOf(this.keyword) !== -1) {
          ret.push(s);
        }
      }
      return ret;
    }
  }
};
</script>
<style lang="scss">
.service-requests {
  .service-requests-list {
    max-height: 350px;
    overflow: auto;
  }
}
</style>
<i18n>
{
  "ka": {
    "addServiceRequest": "სერვისის მოთხოვნა",
    "searchService": "სერვისის ძიება",
    "requestedServices": "მოთხოვნილი სერვისები (ლოდინის რეჟიმში)",
    "fulfiledServicesRequests": "შესრულებული მოთხოვნილი სერვისები",
    "failedServicesRequests": "შეუსრულებული მოთხოვნილი სერვისები",
    "canceledServicesRequests": "გაუქმებული მოთხოვნილი სერვისები",
    "fulfiled": "შესრულდა",
    "failed": "არ შესრულდა",
    "noservicerequests": "მოთხოვნილი სერვისები არ არის",
    "canceled": "გაუქმება"
  },
  "en": {
    "addServiceRequest": "Request Service",
    "searchService": "Search",
    "requestedServices": "Requested Services (Pending)",
    "fulfiledServicesRequests": "Fulfiled Requested Services",
    "failedServicesRequests": "Failed Requested Services",
    "canceledServicesRequests": "Canceled Requested Services",
    "fulfiled": "Fulfiled",
    "failed": "Failed",
    "noservicerequests": "There are no requested services",
    "canceled": "Canceled"
  }
}
</i18n>
